import Calculator from '@core/calc/Calculator';
import ProposalFeesAddedCalculator from '@core/calc/ProposalFeesAddedCalculator';
import ProposalFeesDeductedCalculator from '@core/calc/ProposalFeesDeductedCalculator';

Calculator.registerCalculator('FeesAdded', ProposalFeesAddedCalculator);
Calculator.registerCalculator('FeesDeducted', ProposalFeesDeductedCalculator);
